(() => {
  if (window.f9NavigationReady) return;
  window.f9NavigationReady = true;
  function selectMaterial(scope = document) {
    const family = (new URLSearchParams(location.search).get('material') || '').toLowerCase();
    if (!['marble', 'travertine', 'onyx', 'quartzite'].includes(family)) return;
    scope.querySelectorAll('.f9-material-gallery').forEach(gallery => {
      const button = [...gallery.querySelectorAll('[data-f9-target]')].find(tab => tab.dataset.f9Target.endsWith('-' + family));
      if (button) button.click();
    });
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-f9-brand-category]').forEach(category => {
      if (category.dataset.f9AccordionReady) return;
      category.dataset.f9AccordionReady = 'true';
      category.addEventListener('toggle', () => {
        if (!category.open) return;
        category.closest('.f9-menu-list').querySelectorAll('[data-f9-brand-category]').forEach(other => {
          if (other !== category) other.open = false;
        });
      });
    });
    selectMaterial(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
